'use client';

import { useEffect } from 'react';

import { ErrorFallback } from '@/components/ErrorFallback/ErrorFallback';

export default function GlobalError({ error }: { error: Error & { digest?: string } }): React.ReactNode {
  useEffect(() => {
    console.error('Global error:', error);
  }, [error]);

  return <ErrorFallback error={error} />;
}
